export default [
  {
    url: '/dashboard/analytics',
    name: '个人中心',
    icon: 'HomeIcon',
  },
  {
    url: '/match/list',
    name: '赛事评审',
    slug: 'myMatch',
    icon: 'FlagIcon',
  },
  {
    url: '/exam/list',
    name: '考试评卷',
    slug: '',
    icon: 'Edit3Icon',
  },
  {
    url: '/user/profile',
    name: '个人信息',
    icon: 'UserIcon',
    slug: ''
  },
  {
    header: '其他'
  },
]